// resources/js/jquery-global.js
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
